import LazyMonkeyFactory from './LazyMonkeyFactory';

(window as any).LazyMonkeyPaginationFactory = LazyMonkeyFactory;
const w = window as any;
if (w.lazyMonkeyPaginationSettings) {
  const lazyMonkey = LazyMonkeyFactory.factory(w.lazyMonkeyPaginationSettings);
  lazyMonkey.initialize();
}
